import SequencesContainer from './SequencesContainer';
export default SequencesContainer;
